import React from "react";
import { renderMessageText } from "../../../utils/renderMessageText";
import { parseSharedPostMessage } from "../../../utils/parseSharedPostMessage";
import SharedPostPreview from "./SharedPostPreview";
import styles from "../../../styles/components/profile/MessagesPanel.module.css";

const MessageContent = ({ text }) => {
  const sharedPost = parseSharedPostMessage(text);

  if (!sharedPost) {
    return <p>{renderMessageText(text)}</p>;
  }

  return (
    <>
      {sharedPost.noteText && (
        <p className={styles.messageNote}>{renderMessageText(sharedPost.noteText)}</p>
      )}
      <SharedPostPreview
        postId={sharedPost.postId}
        postPath={sharedPost.postPath}
      />
    </>
  );
};

export default MessageContent;
